<script setup lang="ts">
import { NavigationBreadcrumbs } from '@shared/ui/menus'

import { useCustomerDetailHeader } from '../model/customer-detail-header.hook'

defineOptions({
  name: 'CustomerDetailHeader',
})

const {
  config,
} = useCustomerDetailHeader()
</script>

<template>
  <NavigationBreadcrumbs
    :config="config"
  />
</template>